import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import './Intro.css';
import { Link } from "react-router-dom"; // Add this import


export default function Intro() {
  const navigate = useNavigate();
  const featureRefs = useRef([]);

  useEffect(() => {
    const revealElements = document.querySelectorAll(".reveal");

    const revealOnScroll = () => {
      for (let i = 0; i < revealElements.length; i++) {
        const windowHeight = window.innerHeight;
        const elementTop = revealElements[i].getBoundingClientRect().top;
        const revealPoint = 100;

        if (elementTop < windowHeight - revealPoint) {
          revealElements[i].classList.add("active");
        }
      }
    };

    window.addEventListener("scroll", revealOnScroll);
    revealOnScroll(); // Check on mount

    return () => window.removeEventListener("scroll", revealOnScroll);
  }, []);

  // Typing animation with your actual texts
  const texts = [
    "V-EDITOR",
    "VIJAY",
    "“Code.Chat.Collaborate.”",
    "“Create the Future, Together.”"
  ];
  const [displayText, setDisplayText] = useState("");
  const [textIndex, setTextIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const currentText = texts[textIndex];
    let typingSpeed = 150;

    if (isDeleting) typingSpeed = 50;

    const timeout = setTimeout(() => {
      setDisplayText(prev =>
        isDeleting
          ? currentText.substring(0, prev.length - 1)
          : currentText.substring(0, prev.length + 1)
      );

      if (!isDeleting && displayText === currentText) {
        setTimeout(() => setIsDeleting(true), 2000);
      } else if (isDeleting && displayText === "") {
        setIsDeleting(false);
        setTextIndex((textIndex + 1) % texts.length);
      }
    }, typingSpeed);

    return () => clearTimeout(timeout);
  }, [displayText, isDeleting, textIndex, texts]);

  // Handle guest login
  const handleGuestLogin = () => {
    localStorage.setItem('veditor_user', JSON.stringify({ 
      isGuest: true, 
      name: 'Guest User',
      email: 'guest@example.com',
      joinedAt: new Date().toISOString()
    }));
    navigate("/home");
  };

  // Your actual features based on your code
  const features = [
    {
      icon: "fa-laptop-code",
      title: "Live Coding",
      desc: "Real-time collaborative coding with multiple users",
      color: "#99af4cff"
    },
    {
      icon: "fa-comment-dots",
      title: "Chat While Coding",
      desc: "Integrated team chat for seamless communication",
      color: "#2196f3"
    },
    {
      icon: "fa-microphone",
      title: "Voice Collaboration",
      desc: "High-quality voice chat for better collaboration",
      color: "#ff9800"
    },
    {
      icon: "fa-robot",
      title: "AI Assistance",
      desc: "Smart coding suggestions and real-time help",
      color: "#e91e63"
    }
  ];

  // How it works steps from your code
  const howItWorks = [
    { icon: "fa-user-plus", title: "Sign Up", desc: "Create your account in just seconds.", color: "#4caf50" },
    { icon: "fa-users", title: "Create/Join Room", desc: "Start a coding session or join your team.", color: "#2196f3" },
    { icon: "fa-code", title: "Code Together", desc: "Edit, chat, and collaborate in real time.", color: "#ff9800" },
    { icon: "fa-comment", title: "Chat & Discuss", desc: "Communicate instantly with your team.", color: "#e91e63" },
    { icon: "fa-robot", title: "AI Assistance", desc: "Get smart coding suggestions in real time.", color: "#9c27b0" },
    { icon: "fa-sliders-h", title: "Custom Mode", desc: "Adjust editor settings to your workflow.", color: "#00bcd4" },
    { icon: "fa-brush", title: "Syntax Highlighting", desc: "Color-coded code for readability.", color: "#ffc107" },
    { icon: "fa-language", title: "21 Language Support", desc: "Code in multiple programming languages.", color: "#8bc34a" },
    { icon: "fa-bolt", title: "Fast Typing", desc: "Experience smooth and responsive typing.", color: "#ff5722" },
    { icon: "fa-microphone", title: "Voice Collaboration", desc: "Communicate with audio in real-time.", color: "#795548" },
    { icon: "fa-play-circle", title: "Execute Code", desc: "Run your code directly in the editor.", color: "#009688" }
  ];

  // Testimonials from your code
  const testimonials = [
    "V-EDITOR made pair programming so smooth! — Veer 👨‍💻",
    "Best tool for remote hackathons. — Rao 🚀",
    "Feels like Google Docs but for coding! — Elvish 🎉",
    "Collaboration has never been easier. — Anika 💻",
    "Real-time editing is super smooth! — Karan 🔥",
    "The AI assistant is a game changer! — Priya 🤖",
    "Perfect for team coding sessions. — Sameer 🛠️",
    "I love the integrated chat feature. — Tina 💬",
    "Highly recommend for hackathons! — Rajat 🚀"
  ];

  return (
    <div style={{ 
      background: "#0a0a0a",
      color: "#ffffff",
      fontFamily: "'Poppins', -apple-system, BlinkMacSystemFont, sans-serif",
      overflowX: "hidden",
      width: "100%",
      maxWidth: "100vw"
    }}>
      
      {/* Navigation Bar - Sleek Dark */}
      <nav style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "1rem 5%",
        background: "rgba(10, 10, 10, 0.95)",
        backdropFilter: "blur(10px)",
        borderBottom: "1px solid rgba(255,255,255,0.1)",
        zIndex: 1000
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <img 
            src="/images/logo1.png" 
            alt="V-EDITOR" 
            style={{ height: "35px", width: "auto" }} 
          />
          <span style={{ 
            fontSize: "1.3rem", 
            fontWeight: "600", 
            background: "linear-gradient(135deg, #cab22bff, #ffffff)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent"
          }}>
            V-EDITOR
          </span>
        </div>
        
        <div style={{ display: "flex", gap: "2rem", alignItems: "center" }}>
          <a href="#features" style={{ color: "#e0e0e0", textDecoration: "none", fontSize: "0.95rem" }}>Features</a>
           <a href="abouts.html" style={{ color: "#e0e0e0", textDecoration: "none", fontSize: "0.95rem" }}>ABOUT US</a>
          <a href="#how-it-works" style={{ color: "#e0e0e0", textDecoration: "none", fontSize: "0.95rem" }}>How it Works</a>
          <a href="#testimonials" style={{ color: "#e0e0e0", textDecoration: "none", fontSize: "0.95rem" }}>Reviews</a>
          <button
            onClick={() => navigate("/login")}
            style={{

              padding: "0.5rem 1.2rem",
              background: "transparent",
              border: "1.5px solid #cab22bff",
              borderRadius: "6px",
              color: "#cab22bff",
              fontSize: "0.95rem",
              fontWeight: "500",
              cursor: "pointer",
              transition: "all 0.3s"
            }}
            onMouseEnter={(e) => {
              e.target.style.background = "#cab22bff";
              e.target.style.color = "#000";
            }}
            onMouseLeave={(e) => {
              e.target.style.background = "transparent";
              e.target.style.color = "#cab22bff";
            }}
          >
            Sign In
          </button>
        </div>
      </nav>

      {/* Hero Section - Dark Theme with Gradient */}
      <section className="reveal"
        style={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          padding: "6rem 5% 4rem",
          background: "linear-gradient(135deg, #000000, #1a1a1a)",
          width: "100%",
          boxSizing: "border-box",
          position: "relative"
        }}
      >
        {/* Animated background elements */}
        <div style={{
          position: "absolute",
          top: "20%",
          right: "10%",
          width: "400px",
          height: "400px",
          background: "radial-gradient(circle, rgba(202,178,43,0.1) 0%, transparent 70%)",
          borderRadius: "50%",
          animation: "pulse 4s ease-in-out infinite"
        }}></div>
        <div style={{
          position: "absolute",
          bottom: "20%",
          left: "10%",
          width: "300px",
          height: "300px",
          background: "radial-gradient(circle, rgba(255,255,255,0.05) 0%, transparent 70%)",
          borderRadius: "50%",
          animation: "pulse 6s ease-in-out infinite"
        }}></div>

        <div style={{ position: "relative", zIndex: 1, maxWidth: "800px" }}>
          <img
            src="/images/logo1.png"
            alt="V-EDITOR Logo"
            style={{ 
              width: "100px",
              marginBottom: "2rem",
              animation: "float 3s ease-in-out infinite"
            }}
          />

          <h1 style={{ 
            fontSize: "clamp(2.5rem, 6vw, 4rem)", 
            marginBottom: "1.5rem", 
            minHeight: "5rem",
            fontWeight: "700",
            lineHeight: "1.2",
            color: "#ffffff"
          }}>
            {displayText}
            <span style={{ 
              borderRight: "3px solid #cab22bff", 
              marginLeft: "5px",
              animation: "blink 1s infinite"
            }}></span>
          </h1>

          <p style={{ 
            fontSize: "clamp(1.1rem, 2vw, 1.25rem)", 
            marginBottom: "2.5rem", 
            maxWidth: "600px",
            marginLeft: "auto",
            marginRight: "auto",
            color: "#b0b0b0",
            lineHeight: "1.6"
          }}>
            The modern collaborative editor for <span style={{ color: "#cab22bff", fontWeight: "600" }}>real-time coding</span>.<br />
            Built for developers, teams, and innovators who want to <span style={{ color: "#cab22bff", fontWeight: "600" }}>code together seamlessly</span>.
          </p>

          <div style={{ 
            display: "flex", 
            gap: "1rem", 
            flexWrap: "wrap",
            justifyContent: "center",
            marginBottom: "2rem"
          }}>
            <button
              onClick={() => navigate("/register")}
              style={{
                padding: "1rem 2rem",
                background: "#cab22bff",
                border: "none",
                borderRadius: "8px",
                color: "#000000",
                fontSize: "1rem",
                fontWeight: "600",
                cursor: "pointer",
                minWidth: "160px",
                transition: "all 0.3s",
                boxShadow: "0 4px 15px rgba(202,178,43,0.3)"
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = "translateY(-2px)";
                e.target.style.boxShadow = "0 8px 25px rgba(202,178,43,0.4)";
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = "translateY(0)";
                e.target.style.boxShadow = "0 4px 15px rgba(202,178,43,0.3)";
              }}
            >
              Get Started
            </button>
            
            <button
              onClick={() => navigate("/login")}
              style={{
                padding: "1rem 2rem",
                background: "transparent",
                border: "1px solid #333",
                borderRadius: "8px",
                color: "#ffffff",
                fontSize: "1rem",
                fontWeight: "500",
                cursor: "pointer",
                minWidth: "160px",
                transition: "all 0.3s"
              }}
              onMouseEnter={(e) => {
                e.target.style.background = "rgba(255,255,255,0.05)";
                e.target.style.border = "1px solid #cab22bff";
              }}
              onMouseLeave={(e) => {
                e.target.style.background = "transparent";
                e.target.style.border = "1px solid #333";
              }}
            >
              Login
            </button>
          </div>

          {/* Guest Option */}
          <button
            onClick={handleGuestLogin}
            style={{
              padding: "0.8rem 2rem",
              background: "rgba(255,255,255,0.03)",
              border: "1px dashed #444",
              borderRadius: "8px",
              color: "#b0b0b0",
              fontSize: "0.95rem",
              cursor: "pointer",
              transition: "all 0.3s",
              marginBottom: "3rem"
            }}
            onMouseEnter={(e) => {
              e.target.style.background = "rgba(202,178,43,0.1)";
              e.target.style.border = "1px dashed #cab22bff";
              e.target.style.color = "#cab22bff";
            }}
            onMouseLeave={(e) => {
              e.target.style.background = "rgba(255,255,255,0.03)";
              e.target.style.border = "1px dashed #444";
              e.target.style.color = "#b0b0b0";
            }}
          >
            <i className="fa fa-user-circle" style={{ marginRight: "8px" }}></i>
            Continue as Guest (No registration)
          </button>
        </div>

        <a href="#features" style={{ 
          position: "absolute",
          bottom: "2rem",
          left: "50%",
          transform: "translateX(-50%)",
          color: "#666", 
          textDecoration: "none",
          fontSize: "0.9rem",
          animation: "bounce 2s infinite"
        }}>
          <i className="fa fa-chevron-down"></i> Scroll
        </a>
      </section>

      {/* Features Section - Your Actual Features */}
      <section id="features" className="reveal" style={{ 
        padding: "5rem 5%",
        background: "#0a0a0a",
        width: "100%",
        boxSizing: "border-box"
      }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: "3rem" }}>
            <h2 style={{ 
              fontSize: "clamp(2rem, 4vw, 2.5rem)", 
              marginBottom: "1rem",
              color: "#ffffff",
              fontWeight: "600"
            }}>
              Why Choose <span style={{ color: "#cab22bff" }}>V-EDITOR</span>?
            </h2>
            <p style={{
              color: "#888",
              fontSize: "1.1rem"
            }}>
              Everything you need for seamless collaborative coding
            </p>
          </div>
          
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
              gap: "2rem",
              width: "100%"
            }}
          >
            {features.map((feature, index) => (
              <div
                key={index}
                className="reveal"
                style={{
                  background: "#111",
                  padding: "2.5rem 2rem",
                  borderRadius: "12px",
                  transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                  border: "1px solid #222",
                  textAlign: "center",
                  opacity: "0",
                  transform: "translateY(30px)",
                  animation: index % 2 === 0 ? "slideInLeft 0.6s forwards" : "slideInRight 0.6s forwards",
                  animationDelay: `${index * 0.2}s`
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-10px)";
                  e.currentTarget.style.border = "1px solid #cab22bff";
                  e.currentTarget.style.boxShadow = "0 20px 30px -10px rgba(202,178,43,0.2)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.border = "1px solid #222";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <i className={`fa ${feature.icon}`} style={{ 
                  fontSize: "3rem", 
                  marginBottom: "1.5rem", 
                  color: feature.color 
                }}></i>
                <h3 style={{ 
                  fontSize: "1.3rem", 
                  marginBottom: "1rem",
                  color: "#ffffff",
                  fontWeight: "500"
                }}>
                  {feature.title}
                </h3>
                <p style={{ 
                  color: "#888", 
                  lineHeight: "1.6",
                  fontSize: "0.95rem"
                }}>
                  {feature.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How it Works Section - Your Complete List */}
      <section id="how-it-works" className="reveal" style={{ 
        padding: "5rem 5%",
        background: "#111",
        width: "100%",
        boxSizing: "border-box"
      }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: "3rem" }}>
            <h2 style={{ 
              fontSize: "clamp(2rem, 4vw, 2.5rem)", 
              marginBottom: "1rem",
              color: "#ffffff",
              fontWeight: "600"
            }}>
              How It <span style={{ color: "#cab22bff" }}>Works</span>
            </h2>
            <p style={{
              color: "#888",
              fontSize: "1.1rem"
            }}>
              Get started in minutes with our powerful features
            </p>
          </div>

          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
            gap: "1.5rem"
          }}>
            {howItWorks.map((item, index) => (
              <div
                key={index}
                className="reveal"
                style={{
                  background: "#1a1a1a",
                  padding: "2rem 1.5rem",
                  borderRadius: "10px",
                  border: "1px solid #222",
                  textAlign: "center",
                  transition: "all 0.3s",
                  opacity: "0",
                  transform: "scale(0.9)",
                  animation: "popIn 0.5s forwards",
                  animationDelay: `${index * 0.1}s`
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "scale(1.05)";
                  e.currentTarget.style.border = "1px solid #cab22bff";
                  e.currentTarget.style.background = "#222";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                  e.currentTarget.style.border = "1px solid #222";
                  e.currentTarget.style.background = "#1a1a1a";
                }}
              >
                <i className={`fa ${item.icon}`} style={{ 
                  fontSize: "2rem", 
                  marginBottom: "1rem", 
                  color: item.color 
                }}></i>
                <h3 style={{ 
                  fontSize: "1.1rem", 
                  marginBottom: "0.5rem",
                  color: "#ffffff",
                  fontWeight: "500"
                }}>
                  {item.title}
                </h3>
                <p style={{ 
                  color: "#888", 
                  fontSize: "0.9rem",
                  lineHeight: "1.5"
                }}>
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section - Your Testimonials */}
      <section id="testimonials" className="reveal" style={{ 
        padding: "5rem 5%",
        background: "#0a0a0a",
        width: "100%",
        boxSizing: "border-box"
      }}>
        <div style={{ maxWidth: "1000px", margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: "3rem" }}>
            <h2 style={{ 
              fontSize: "clamp(2rem, 4vw, 2.5rem)", 
              marginBottom: "1rem",
              color: "#ffffff",
              fontWeight: "600"
            }}>
              What <span style={{ color: "#cab22bff" }}>Developers</span> Say
            </h2>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
              gap: "1.5rem"
            }}
          >
            {testimonials.map((testimonial, index) => (
              <div
                key={index}
                className="reveal"
                style={{
                  background: "#111",
                  padding: "1.5rem",
                  borderRadius: "10px",
                  border: "1px solid #222",
                  transition: "all 0.3s",
                  opacity: "0",
                  transform: "translateX(-20px)",
                  animation: "slideIn 0.5s forwards",
                  animationDelay: `${index * 0.1}s`
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateX(5px)";
                  e.currentTarget.style.border = "1px solid #cab22bff";
                  e.currentTarget.style.background = "#1a1a1a";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateX(0)";
                  e.currentTarget.style.border = "1px solid #222";
                  e.currentTarget.style.background = "#111";
                }}
              >
                <div style={{ color: "#cab22bff", marginBottom: "1rem" }}>
                  {"★".repeat(5)}
                </div>
                <p style={{ 
                  color: "#e0e0e0", 
                  lineHeight: "1.6",
                  fontStyle: "italic",
                  marginBottom: "0.5rem"
                }}>
                  "{testimonial}"
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{
        padding: "5rem 5%",
        background: "linear-gradient(135deg, #000000, #1a1a1a)",
        textAlign: "center",
        borderTop: "1px solid #222",
        borderBottom: "1px solid #222"
      }}>
        <div style={{ maxWidth: "600px", margin: "0 auto" }}>
          <h2 style={{ 
            fontSize: "clamp(2rem, 4vw, 2.5rem)", 
            marginBottom: "1rem",
            color: "#ffffff",
            fontWeight: "600"
          }}>
            Ready to <span style={{ color: "#cab22bff" }}>Code Together</span>?
          </h2>
          
          <div style={{ display: "flex", gap: "1rem", justifyContent: "center", flexWrap: "wrap" }}>
            <button
              onClick={() => navigate("/register")}
              style={{
                padding: "1rem 2.5rem",
                background: "#cab22bff",
                border: "none",
                borderRadius: "8px",
                color: "#000",
                fontSize: "1.1rem",
                fontWeight: "600",
                cursor: "pointer",
                transition: "all 0.3s"
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = "scale(1.05)";
                e.target.style.boxShadow = "0 10px 25px rgba(202,178,43,0.3)";
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = "scale(1)";
                e.target.style.boxShadow = "none";
              }}
            >
              Get Started Free
            </button>
            
            <button
              onClick={handleGuestLogin}
              style={{
                padding: "1rem 2.5rem",
                background: "transparent",
                border: "1px solid #333",
                borderRadius: "8px",
                color: "#fff",
                fontSize: "1.1rem",
                cursor: "pointer",
                transition: "all 0.3s"
              }}
              onMouseEnter={(e) => {
                e.target.style.background = "rgba(202,178,43,0.1)";
                e.target.style.border = "1px solid #cab22bff";
              }}
              onMouseLeave={(e) => {
                e.target.style.background = "transparent";
                e.target.style.border = "1px solid #333";
              }}
            >
              Try as Guest
            </button>
          </div>

          <p style={{ 
            marginTop: "2rem",
            color: "#666",
            fontSize: "0.9rem"
          }}>
            <i className="fa fa-code"></i> Code. Chat. Collaborate.
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer style={{ 
        padding: "3rem 5% 2rem",
        background: "#000",
        borderTop: "1px solid #111"
      }}>
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
          gap: "2rem",
          maxWidth: "1200px",
          margin: "0 auto 2rem"
        }}>
          <div>
            <img src="/images/logo1.png" alt="V-EDITOR" style={{ height: "30px", marginBottom: "1rem" }} />
            <p style={{ color: "#666", fontSize: "0.9rem" }}>Code. Chat. Collaborate.</p>
          </div>
          
          <div>
            <h4 style={{ color: "#fff", marginBottom: "1rem", fontSize: "1rem" }}>Product</h4>
            <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
              <a href="#features" style={{ color: "#666", textDecoration: "none", fontSize: "0.9rem" }}>Features</a>
              <a href="#how-it-works" style={{ color: "#666", textDecoration: "none", fontSize: "0.9rem" }}>How it Works</a>
            </div>
          </div>
          
          <div>
            <h4 style={{ color: "#fff", marginBottom: "1rem", fontSize: "1rem" }}>Connect</h4>
            <div style={{ display: "flex", gap: "1rem" }}>
              <a href="https://www.linkedin.com/in/vijayyadav123/" style={{ color: "#666", fontSize: "1.2rem" }}>
                <i className="fa fa-linkedin"></i>
              </a>
              <a href="https://www.instagram.com/kidvijay" style={{ color: "#666", fontSize: "1.2rem" }}>
                <i className="fa fa-instagram"></i>
              </a>
 {/* Contact (same style) */}
    <Link
      to="/contact"
      style={{ color: "#666", fontSize: "1.2rem" }}
    >
      <i className="fa fa-envelope"></i>
    </Link>              
            </div>
          </div>
          
          <div>
            <h4 style={{ color: "#fff", marginBottom: "1rem", fontSize: "1rem" }}>Legal</h4>
            <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
              <a href="/privacy" style={{ color: "#666", textDecoration: "none", fontSize: "0.9rem" }}>Privacy</a>
              <a href="/terms" style={{ color: "#666", textDecoration: "none", fontSize: "0.9rem" }}>Terms</a>
            </div>
          </div>
        </div>
        
        <hr style={{ border: "1px solid #111", margin: "2rem 0" }} />
        
        <p style={{ textAlign: "center", color: "#444", fontSize: "0.9rem" }}>
          © {new Date().getFullYear()} V-EDITOR • Built for developers, by developers
        </p>
      </footer>

      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap');
          
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }
          
          body {
            font-family: 'Poppins', sans-serif;
            background: #0a0a0a;
          }
          
          @keyframes blink {
            0%, 50% { opacity: 1; }
            51%, 100% { opacity: 0; }
          }
          
          @keyframes bounce {
            0%, 20%, 50%, 80%, 100% { transform: translateX(-50%) translateY(0); }
            40% { transform: translateX(-50%) translateY(-10px); }
            60% { transform: translateX(-50%) translateY(-5px); }
          }
          
          @keyframes pulse {
            0%, 100% { transform: scale(1); opacity: 0.5; }
            50% { transform: scale(1.1); opacity: 0.8; }
          }
          
          @keyframes float {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-10px); }
          }
          
          @keyframes slideInLeft {
            from {
              opacity: 0;
              transform: translateX(-50px);
            }
            to {
              opacity: 1;
              transform: translateX(0);
            }
          }
          
          @keyframes slideInRight {
            from {
              opacity: 0;
              transform: translateX(50px);
            }
            to {
              opacity: 1;
              transform: translateX(0);
            }
          }
          
          @keyframes slideIn {
            from {
              opacity: 0;
              transform: translateX(-20px);
            }
            to {
              opacity: 1;
              transform: translateX(0);
            }
          }
          
          @keyframes popIn {
            from {
              opacity: 0;
              transform: scale(0.8);
            }
            to {
              opacity: 1;
              transform: scale(1);
            }
          }
          
          .reveal {
            opacity: 0;
            transform: translateY(30px);
            transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
          }
          
          .reveal.active {
            opacity: 1;
            transform: translateY(0);
          }
          
          html {
            scroll-behavior: smooth;
          }
        `}
      </style>
    </div>
  );
}